import { render, staticRenderFns } from "./FinishView.vue?vue&type=template&id=1b5361d8&scoped=true"
var script = {}
import style0 from "./FinishView.vue?vue&type=style&index=0&id=1b5361d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5361d8",
  null
  
)

export default component.exports